import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Save, ArrowLeft, User, Mail, FileText } from "lucide-react";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { mockUser } from "../data/mockData";
import styles from "./EditProfilePage.module.css";

export function EditProfilePage() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: mockUser?.name ?? "",
    email: mockUser?.email ?? "",
    bio: mockUser?.bio ?? "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Mock save: just navigate back for now
    navigate("/profile");
  };

  return (
    <div className={styles.container}>
      <Header />
      <main className={styles.main}>
        <div className={styles.wrapper}>
          <div className={styles.headerRow}>
            <motion.button
              type="button"
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.97 }}
              className={styles.backBtn}
              onClick={() => navigate("/profile")}
            >
              <ArrowLeft className={styles.iconSmall} />
              Back
            </motion.button>

            <div className={styles.titles}>
              <h1 className={styles.title}>Edit Profile</h1>
              <p className={styles.subtitle}>Update your basic info.</p>
            </div>
          </div>

          <motion.form
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            className={styles.card}
            onSubmit={handleSubmit}
          >
            <div className={styles.field}>
              <label className={styles.label} htmlFor="name">
                Name
              </label>
              <div className={styles.inputWrap}>
                <User className={styles.inputIcon} />
                <input
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className={styles.input}
                  placeholder="Your name"
                  required
                />
              </div>
            </div>

            <div className={styles.field}>
              <label className={styles.label} htmlFor="email">
                Email
              </label>
              <div className={styles.inputWrap}>
                <Mail className={styles.inputIcon} />
                <input
                  id="email"
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className={styles.input}
                  placeholder="you@example.com"
                />
              </div>
            </div>

            <div className={styles.field}>
              <label className={styles.label} htmlFor="bio">
                Bio
              </label>
              <div className={styles.textareaWrap}>
                <FileText className={styles.inputIconTop} />
                <textarea
                  id="bio"
                  name="bio"
                  value={formData.bio}
                  onChange={handleChange}
                  className={styles.textarea}
                  placeholder="Tell people what you cook..."
                  rows={5}
                />
              </div>
            </div>

            <div className={styles.actions}>
              <motion.button
                type="button"
                whileHover={{ scale: 1.03 }}
                whileTap={{ scale: 0.97 }}
                className={styles.ghostBtn}
                onClick={() => navigate("/profile")}
              >
                Cancel
              </motion.button>
              <motion.button
                type="submit"
                whileHover={{ scale: 1.03 }}
                whileTap={{ scale: 0.97 }}
                className={styles.saveBtn}
              >
                <Save className={styles.iconSmall} />
                Save
              </motion.button>
            </div>
          </motion.form>
        </div>
      </main>
      <Footer />
    </div>
  );
}

